export default __webpack_public_path__ + "static/media/redfic.a725ff49.png";